var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowTopLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8761_19623)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_8761_19623)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.1222 19.7221C23.0518 18.7925 24.5483 18.7925 25.4779 19.7221C25.485 19.7292 25.492 19.7364 25.4989 19.7437L32.5989 27.2437L31.0012 28.7561L23.9161 21.2718C23.848 21.2093 23.7521 21.2093 23.684 21.2718L16.5989 28.7561L15.0012 27.2437L22.1012 19.7437C22.1081 19.7364 22.1151 19.7292 22.1222 19.7221Z",
    fill: "#121619"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8761_19623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_8761_19623"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.6,
    height: 9.7,
    fill: "white",
    transform: "translate(15 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowTopLight);
export default __webpack_public_path__ + "static/media/icon_arrow_top_light.5b195e6c.svg";
export { ForwardRef as ReactComponent };